module.exports = __webpack_public_path__ + "img/proyects.6e2d0f83.svg";